import { some } from '@utils/some';
import { DiningOption, DynamicPackagesFormStepNames, FormStep, PackageRestaurant } from '../types';
import {
  getRepeatableExperienceOccurrenceDays,
  groupRepeatableExperiencesByDay,
} from './repeatableExperiencesUtils';

export function getTablesSteps(
  restaurants: PackageRestaurant[],
  isPackageRepeating: boolean,
  stayDuration: number
): FormStep[] {
  let diningOptions: DiningOption[] = [];
  if (!isPackageRepeating) {
    restaurants.forEach((r) => {
      diningOptions.push({
        id: Number(r.restaurantId),
        name: r.name ?? '',
        menuIds: (r.menuIds || []).map((id) => Number(id)),
        timeslotRestrictions: r.timeRestrictions,
        delayAfter: r.delayAfter,
        dayNumber: r.dayNumber,
      });
    });
  }
  if (isPackageRepeating) {
    diningOptions = distributeRepeatingPackageDining(restaurants, stayDuration);
  }
  return some(diningOptions)
    ? [
        {
          step: DynamicPackagesFormStepNames.TABLES,
          type: 'tables',
          diningOptions,
        },
      ]
    : [];
}

export function distributeRepeatingPackageDining(
  restaurants: PackageRestaurant[],
  stayDuration: number
): DiningOption[] {
  const { day0, day1 } = groupRepeatableExperiencesByDay(restaurants);

  const diningOptions: DiningOption[] = [];

  for (let dayIndex = 0; dayIndex <= stayDuration; dayIndex++) {
    // Day 0 dining: Available on check-in through night before checkout
    const day0Days = getRepeatableExperienceOccurrenceDays({
      experienceDayNumber: 0,
      stayDuration,
    });
    if (day0Days.includes(dayIndex) && day0.length > 0) {
      day0.forEach((r) => {
        diningOptions.push({
          id: Number(r.restaurantId),
          name: r.name ?? '',
          menuIds: (r.menuIds || []).map((id) => Number(id)),
          timeslotRestrictions: r.timeRestrictions,
          delayAfter: r.delayAfter,
          dayNumber: dayIndex,
        });
      });
    }

    // Day 1 dining: Available day after check-in through checkout
    const day1Days = getRepeatableExperienceOccurrenceDays({
      experienceDayNumber: 1,
      stayDuration,
    });
    if (day1Days.includes(dayIndex) && day1.length > 0) {
      day1.forEach((r) => {
        diningOptions.push({
          id: Number(r.restaurantId),
          name: r.name ?? '',
          menuIds: (r.menuIds || []).map((id) => Number(id)),
          timeslotRestrictions: r.timeRestrictions,
          delayAfter: r.delayAfter,
          dayNumber: dayIndex,
        });
      });
    }
  }

  return diningOptions;
}
